import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox", "input", "toggleTarget"]
  static values = {
    defaultValue: String,
    disabledValue: String,
    hideOnDisabled: Boolean
  }

  connect() {
    this.updateInputState()
  }

  toggle(event) {
    this.updateInputState()
  }

  updateInputState() {
    const isChecked = this.checkboxTarget.checked
    
    if (isChecked) {
      this.enableInput()
    } else {
      this.disableInput()
    }
  }

  enableInput() {
    this.toggleTargetTarget.classList.remove('filter--notMatch')
    
    if (this.hasDefaultValueValue && 
        (this.inputTarget.value === this.disabledValueValue || this.inputTarget.value === '')) {
      this.inputTarget.value = this.defaultValueValue
    }
  }

  disableInput() {
    this.toggleTargetTarget.classList.add('filter--notMatch')
    
    if (this.hasDisabledValueValue) {
      this.inputTarget.value = this.disabledValueValue
    }
  }

  // Default values
  get defaultValueValue() {
    return this.hasDefaultValueValue ? this.data.get("defaultValue") : "1"
  }

  get disabledValueValue() {
    return this.hasDisabledValueValue ? this.data.get("disabledValue") : "0"
  }

  get hideOnDisabledValue() {
    return this.hasHideOnDisabledValue ? this.data.get("hideOnDisabled") === "true" : true
  }
}